'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Highcharts = _interopDefault(require('highcharts'));
var highchartsMore = _interopDefault(require('highcharts/highcharts-more'));
var solidGauge = _interopDefault(require('highcharts/modules/solid-gauge'));
var HighchartsReact = _interopDefault(require('highcharts-react-official'));
var LoadingSpinner = require('../../LoadingSpinner/LoadingSpinner.js');
var utils = require('./utils.js');
var constants = require('./constants.js');

highchartsMore(Highcharts);
solidGauge(Highcharts);
var PieChart = function (props) {
    var _a = props.legendVerticalShift, legendVerticalShift = _a === void 0 ? 0 : _a, _b = props.outerRadius, outerRadius = _b === void 0 ? 100 : _b, _c = props.values, values = _c === void 0 ? [1, 2, 3, 4, 5] : _c, _d = props.titles, titles = _d === void 0 ? ['a', 'b', 'c', 'd', 'e'] : _d, _e = props.colors, colors = _e === void 0 ? ['#4C7CFD', '#A8B3C3', '#96C7FF', '#D0DDEE', '#2D5EC7'] : _e, _f = props.height, height = _f === void 0 ? null : _f, _g = props.loading, loading = _g === void 0 ? false : _g, tooltipFormatter = props.tooltipFormatter;
    var legend = constants.generateLegend();
    legend.y = legendVerticalShift;
    var options = utils.generateOptions({
        height: height,
        legend: legend,
        values: values,
        titles: titles,
        colors: colors,
        outerRadius: outerRadius,
        tooltipFormatter: tooltipFormatter,
    });
    return (React__default.createElement(LoadingSpinner, { isLoading: loading },
        React__default.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};

module.exports = PieChart;
